import { useEffect, } from "react";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
// import Home from "./components/Home";
import Layout from "./components/Layout";
// import Resume from "./components/Resume";
import GlobalStyle from "./components/styles/GlobalStyles";
// import { fetchRepos } from "./components/utils/helper";
// import Writings from "./components/Writings";
import { Helmet } from "react-helmet";

const AppContainer = styled.main`
  & > * {
    overflow-x: hidden;
  }
`;

function App() {
  // const [repos, setRepos] = useState([]);
  const newWebsite = "https://akot.vercel.app/";
  useEffect(() => {
    // fetchRepos(setRepos);
    redirectTo(newWebsite);
  }, []);

  function redirectTo(url) {
    window.location.href = url;
  }

  return (
    <AppContainer>
      <Helmet>
        <title>AKOT PORTFOLIO. </title>
        <meta
          name="description"
          content="AKOT , a frontend developer with years of experience ..."
        />
        <meta
          name="keywords"
          content="job, work, portfolio, frontend, web developer, software engineer, world, application, developer, integration, bank, banking, loan, savings, roi, Transfer, Invoice, payroll,  interest, nigeria, africa, fintech"
        />
        <meta name="page-topic" content="PORTFOLIO" />
        <meta name="page-type" content="Landing" />
        <meta name="audience" content="Everyone" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dvgwgaqrk/image/upload/v1719950490/favicon_z86v3n.png"
        />
        <meta
          property="og:url"
          content="https://res.cloudinary.com/dvgwgaqrk/image/upload/v1719950490/favicon_z86v3n.png"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="twitter:image:src"
          content="https://res.cloudinary.com/dvgwgaqrk/image/upload/v1719950490/favicon_z86v3n.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image:alt" content="AKOTPORTFOLIO" />
        <meta name="twitter:site" content="https://x.com/KEHINDED_" />
        <meta
          httpEquiv="Content-Security-Policy"
          content="default-src * self blob: data: gap:; style-src * self 'unsafe-inline' blob: data: gap:; script-src * 'self' 'unsafe-eval' 'unsafe-inline' blob: data: gap:; object-src * 'self' blob: data: gap:; img-src * self 'unsafe-inline' blob: data: gap:; connect-src self * 'unsafe-inline' blob: data: gap:; frame-src * self blob: data: gap:;"
        />
        <meta
          key="cache-control"
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta key="pragma" http-equiv="Pragma" content="no-cache" />
        <meta key="expires" http-equiv="Expires" content="0" />
      </Helmet>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* <Route index element={<Home repos={repos} setRepos={setRepos} />} />
          <Route path="resume" element={<Resume />} />
          <Route path="write-ups" element={<Writings />} /> */}
        </Route>
      </Routes>
    </AppContainer>
  );
}

export default App;
